import { render } from "./ArrowLeft.vue?vue&type=template&id=189cfa46&scoped=true"
const script = {}

import "./ArrowLeft.vue?vue&type=style&index=0&id=189cfa46&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-189cfa46"]])

export default __exports__